<template>
    <div class="mt-4 mb-5 text-center">
        <button
            type="button"
            class="btn btn-md text-uppercase"
            @click="closeFloorOpen"
        >
            Späť na výber poschodí
        </button>
    </div>
</template>

<script>
export default {
    inject: ['closeFloorOpen'],
};
</script>

<style lang="scss" scoped>
button {
    background: #fff;
    border: 2px solid #231E1E;
    color: #231E1E;
    padding: 1rem 1.4rem;

    &:hover,
    &:focus {
        background: #231E1E;
        color: #fff;
    }
}
</style>
